<template>
  <spinner-container :loading="loading">
    <back-btn/>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <sympton-form :sympton="sympton" @emitSymptonData="updateSympton" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import SymptonForm from "@/components/sympton/SymptonForm";
import { mapState } from "vuex";
import SpinnerContainer from '../../components/container/SpinnerContainer.vue';
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    SymptonForm,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({
  }),
  computed: {
    ...mapState("Sympton", ["sympton"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    updateSympton(payload) {
      this.$store.dispatch("Sympton/updateSympton", payload).then(() => {
        this.$router.push("/sympton");
      });
    },
  },
  created() {
    this.$store.dispatch("Sympton/getSympton", this.$route.params.id);
  },
};
</script>
